import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/video/InksquadBannerVideo.mp4'
import _imports_1 from '@/assets/InksquadsVideoBanner.jpg'


const _withScopeId = n => (_pushScopeId("data-v-5561cb10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "video-wrap w-full block overflow-hidden absolute" }, [
  /*#__PURE__*/_createElementVNode("video", {
    class: "banner opacity-60",
    src: _imports_0,
    poster: _imports_1,
    muted: "muted",
    autoplay: "autoplay",
    loop: "loop",
    playsinline: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "h-full w-full absolute top-0" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "shadow-layer bg-gradient-to-t from-gray-400 w-full -bottom-4 h-full lg:h-full md:block lg:-bottom-2" })
  ])
], -1))
const _hoisted_3 = { class: "title-home z-50 flex justify-center items-center m-auto lg:top-60 w-10/12 lg:2/4" }
const _hoisted_4 = { class: "content-wrap w-full" }
const _hoisted_5 = { class: "boxed m-auto mt-4 w-10/12 lg:w-2/4" }
const _hoisted_6 = { class: "wide-section m-auto w-10/12 lg:w-5/6 lg:m-auto" }
const _hoisted_7 = { class: "wide-section m-auto w-10/12 lg:w-5/6 lg:m-auto" }
const _hoisted_8 = { class: "boxed m-auto pt-20 m-auto w-10/12 lg:w-2/4" }
const _hoisted_9 = { class: "wide-section m-auto w-10/12 lg:w-5/6 lg:m-auto" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wide-section m-auto w-10/12 lg:w-5/6 lg:m-auto" }, null, -1))
const _hoisted_11 = {
  class: "wide-section pt-20 m-auto mt-20 w-10/12 lg:w-5/6 lg:m-auto lg:mt-64",
  id: "support"
}
const _hoisted_12 = { class: "boxed m-auto m-auto w-10/12 lg:w-5/6" }
const _hoisted_13 = {
  key: 0,
  class: "fixed bottom-0 w-full bg-black p-8 block space-y-6 z-50 sm:flex"
}
const _hoisted_14 = { class: "relative" }
const _hoisted_15 = { class: "leading-normal text-white text-left text-base md:text-base lg:text-base" }
const _hoisted_16 = { class: "m-2 flex text-center" }
const _hoisted_17 = {
  class: "m-auto border-2 border-white text-white bg-white rounded-full uppercase button-text px-4 py-2 cursor-pointer truncate special-download font-bold gradient-animated text-center hover:bg-gray-300",
  href: "https://aitattoo62.com",
  target: "_blank"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InkboardTitle = _resolveComponent("InkboardTitle")!
  const _component_InkboardSecondTitle = _resolveComponent("InkboardSecondTitle")!
  const _component_MockupInkboards1 = _resolveComponent("MockupInkboards1")!
  const _component_MockupInkboards2 = _resolveComponent("MockupInkboards2")!
  const _component_CatalogsTitle = _resolveComponent("CatalogsTitle")!
  const _component_MockupCatalogs1 = _resolveComponent("MockupCatalogs1")!
  const _component_FAQ = _resolveComponent("FAQ")!
  const _component_DownloadSection = _resolveComponent("DownloadSection")!
  const _component_FooterSection = _resolveComponent("FooterSection")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_InkboardTitle)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_InkboardSecondTitle)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_MockupInkboards1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_MockupInkboards2)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_CatalogsTitle)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_MockupCatalogs1)
      ]),
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_FAQ)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_DownloadSection)
      ])
    ]),
    _createVNode(_component_FooterSection, { class: "pt-20 m-auto top-shift w-10/12 lg:w-5/6" }),
    (_ctx.isPresentingBanner)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: "button absolute -top-6 -right-6 text-white text-2xl items-center flex",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isPresentingBanner = false))
            }, [
              _createVNode(_component_font_awesome_icon, {
                class: "h-6 w-6",
                icon: ['fas', 'close']
              })
            ]),
            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('components.top-bar.get-inksquad-ai-banner')), 1),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("a", _hoisted_17, _toDisplayString(_ctx.$t('components.top-bar.get-inksquad-ai')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}